import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";

import scan from "../../assets/module-2/2-1-5-scan.png";
import LdsImage from "../../components/LdsImage";
import FigureCaption from "../../components/LdsFigureCaption";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_2_1_1 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section>
            <h1 className="blue text-uppercase b mt-5 mb-4">
              2.1.5 Neuroanatomy: Identifying Regions of Interest
            </h1>
            <p className="me-4">Estimated time to complete: 1 minute</p>
          </section>

          <section className="row mt-5 mb-4 justify-content-center">
            <div className="col text-center">
              <FigureCaption
                noCollapse={true}
                className="figcaption-no-border align-items-center flex-column d-flex"
                radiusSize="small"
                textContent={
                  <>
                    <p className="text-center">
                      &copy;2016. Avid Radiopharmaceuticals, Inc. All rights
                      reserved.
                    </p>
                  </>
                }
              >
                <LdsImage
                  src={scan}
                  alt="Sagittal MRI brain scan showing a side view of the brain, highlighting structures like the cerebrum, cerebellum, and brainstem with a green horizontal line across the image. Axial MRI scan of the brain showing labeled regions, including the frontal lobe, anterior cingulate, posterior cingulate, parietal cortex, corona radiata, and precuneus. Each structure is outlined and color-coded for clarity."
                  style={{ maxWidth: "1064px" }}
                />
              </FigureCaption>
            </div>
          </section>

          <section>
            <p>
              Moving superiorly still, both the anterior and posterior portions
              of the cingulate, the precuneus, and the white matter tracts of
              the corona radiata, as well as the frontal and parietal lobes
              continue to be seen.
            </p>
            <p>
              It is important to be familiar with the location of these regions
              in the normal brain, as their location may shift with significant
              atrophy and ventricular enlargement in some patients with AD or
              other neurologic conditions.
            </p>
          </section>

          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-2/module-2-1-4", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              onClick={function navClick() {
                window.open("/module-2/module-2-2-0", "_self");
              }}
            >
              Next Lesson
            </LdsButton>
          </section>
        </main>
      </div>
    </div>
  );
};

export default Module_2_1_1;
